<h2 class="filter-title">Advanced Filter</h2>
<form [formGroup]="formGroup"
      (ngSubmit)="applyFilter()">
    <section class="date-range">
        <h3 class="section-title">Date Range</h3>
        <mat-radio-group formControlName="dateRangeType"
                         class="date-range-types">
            @for (dateRangeType of dateRangeTypes;track dateRangeType) {
                <mat-radio-button [value]="dateRangeType">{{ dateRangeType }}</mat-radio-button>
            }
        </mat-radio-group>

        <mat-form-field>
            <mat-label>{{ formGroup?.controls.dateRangeType.value || 'Start-End Dates' }}</mat-label>
            <mat-date-range-input [rangePicker]="picker"
                                  [disabled]="formGroup?.controls.dateRangeType.value === null"
                                  [min]="minDate"
                                  [max]="maxDate">
                <input matStartDate
                       formControlName="dateRangeStart"
                       readonly>
                <input matEndDate
                       formControlName="dateRangeEnd"
                       readonly>
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix
                                   [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </section>

    <section class="balance">
        <h3 class="section-title">Invoice Balance</h3>
        <div class="balance-inputs">
            <mat-form-field [subscriptSizing]="'dynamic'">
                <mat-label>Minimum</mat-label>
                <input type="number"
                       [min]="minBalance"
                       [max]="maxBalance"
                       matInput
                       formControlName="invoiceBalanceMin">
                <span class="material-symbols-rounded"
                      matPrefix>attach_money</span>
            </mat-form-field>
            <mat-form-field [subscriptSizing]="'dynamic'">
                <mat-label>Maximum</mat-label>
                <input type="number"
                       [min]="minBalance"
                       [max]="maxBalance"
                       matInput
                       formControlName="invoiceBalanceMax">
                <span class="material-symbols-rounded"
                      matPrefix>attach_money</span>
            </mat-form-field>
        </div>

        @if (formGroup?.controls.invoiceBalanceMin.errors) {
            <mat-error>{{ formGroup?.controls.invoiceBalanceMin.errors | firstErrorMessage }}</mat-error>
        }

        @if (formGroup?.controls.invoiceBalanceMax.errors) {
            <mat-error>{{ formGroup?.controls.invoiceBalanceMax.errors | firstErrorMessage }}</mat-error>
        }

        <div class="slider-wrapper">
            <mat-slider [min]="minBalance"
                        [max]="maxBalance"
                        [ngStyle]="{
                        '--min-balance': '\'' + (minBalance | number) + '\'',
                        '--max-balance': '\'' + (maxBalance | number) + '\''
                        }"
                        [discrete]="true">
                <input [value]="formGroup?.controls.invoiceBalanceMin.value"
                       (valueChange)="formGroup?.controls.invoiceBalanceMin.setValue($event)"
                       matSliderStartThumb>
                <input [value]="formGroup?.controls.invoiceBalanceMax.value"
                       (valueChange)="formGroup?.controls.invoiceBalanceMax.setValue($event)"
                       matSliderEndThumb>
            </mat-slider>
        </div>
    </section>

    <section class="status">
        <h3 class="section-title">Search for Status</h3>
        <mat-form-field>
            <mat-label>Payment Status</mat-label>
            <mat-select formControlName="paymentStatuses"
                        multiple>
                @for (status of paymentStatusCategories;track status) {
                    <mat-option [value]="status">{{ status }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Point Status</mat-label>
            <mat-select formControlName="pointStatuses"
                        multiple>
                @for (status of pointStatusCategories;track status) {
                    <mat-option [value]="status">{{ status }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </section>

    <div class="actions">
        <button mat-flat-button
                color="primary"
                type="submit"
                [disabled]="!formGroup?.valid"
                class="action capsule">
            <span>Apply</span>
            <span class="material-symbols-rounded" matSuffix>chevron_right</span>
        </button>
        <button mat-stroked-button
                color="primary"
                type="reset"
                (click)="resetForm($event)"
                class="action capsule">
            <span>Reset</span>
            <span class="material-symbols-rounded" matSuffix>chevron_right</span>
        </button>
    </div>
</form>
